import {
  countWhenFieldDateAfter,
  countWhenFieldDateBefore,
  countWhenFieldEquals,
  countWhenAllFieldsEqual,
  countWhenFieldNotEquals,
  countWhenFieldNumberGreaterThan,
  countWhenFieldNumberLessThan,
} from '@app/finxone-web-frontend/app/lib/utils/template/handlebar-helpers/count-when-field-equals.helper';

// Add the helpers here that can be used in the responsive hide conditions.
// These need testing as they are added.
// Example usage: countWhenFieldEquals(savingsAccounts.accounts, 'metadata.thisbank.maxNrOfWithdrawal', 3) > 0
export const responsiveHideHelpers = {
  countWhenFieldEquals,
  countWhenAllFieldsEqual,
  countWhenFieldNotEquals,
  countWhenFieldNumberGreaterThan,
  countWhenFieldNumberLessThan,
  countWhenFieldDateBefore,
  countWhenFieldDateAfter,
};
